import { create } from 'zustand';
import authApi from '../api/auth';

const storedUser = (() => {
  try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
})();

const useAuthStore = create((set) => ({
  user: storedUser || null,
  token: localStorage.getItem('access_token') || null,
  loading: false,
  error: null,

  setUser: (user) => set({ user }),

  clearAuth: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    set({ user: null, token: null, error: null });
  },

  oldLogin: async (phone, password) => {
    set({ loading: true, error: null });
    try {
      const res = await authApi.oldLogin(phone, password, 'Web Browser');
      const { user, access_token } = res.data.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      set({ user, token: access_token, loading: false });
      return { success: true };
    } catch (err) {
      const message = err.response?.data?.message || 'Xatolik yuz berdi';
      set({ error: message, loading: false });
      return { success: false, message };
    }
  },

  oldRegister: async (fullname, phone, password, isvendor = false) => {
    set({ loading: true, error: null });
    try {
      const res = await authApi.oldRegister(fullname, phone, password, password, isvendor);
      const { user, access_token } = res.data.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      set({ user, token: access_token, loading: false });
      return { success: true };
    } catch (err) {
      const message = err.response?.data?.message || 'Xatolik yuz berdi';
      set({ error: message, loading: false });
      return { success: false, message };
    }
  },

  sendOtp: async (phone) => {
    set({ loading: true, error: null });
    try {
      const res = await authApi.sendOtp(phone);
      set({ loading: false });
      return { success: true, data: res.data.data };
    } catch (err) {
      const message = err.response?.data?.message || 'Xatolik yuz berdi';
      set({ error: message, loading: false });
      return { success: false, message };
    }
  },

  verifyOtp: async (phone, otp) => {
    set({ loading: true, error: null });
    try {
      const res = await authApi.verifyOtp(phone, otp, 'Web Browser');
      const { user, access_token } = res.data.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      set({ user, token: access_token, loading: false });
      return { success: true };
    } catch (err) {
      const message = err.response?.data?.message || 'Xatolik yuz berdi';
      const attemptsLeft = err.response?.data?.data?.attempts_left;
      set({ error: message, loading: false });
      return { success: false, message, attemptsLeft };
    }
  },

  logout: async () => {
    try {
      await authApi.logout();
    } catch {}
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    set({ user: null, token: null, error: null });
  },

  fetchMe: async () => {
    set({ loading: true });
    try {
      const res = await authApi.me();
      const user = res.data.data;
      localStorage.setItem('user', JSON.stringify(user));
      set({ user, loading: false });
    } catch {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      set({ user: null, token: null, loading: false });
    }
  },
}));

export default useAuthStore;
